import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c4af5fa4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "testimonial" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "author" };
const _hoisted_4 = { class: "company" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'testimonial',
    props: {
        d: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("blockquote", null, [
                        _createTextVNode(_toDisplayString(_ctx.d.testimonial.quote) + " ", 1),
                        _createElementVNode("figcaption", null, [
                            _createElementVNode("cite", _hoisted_3, _toDisplayString(_ctx.d.testimonial.name + ' - ' + _ctx.d.testimonial.position), 1),
                            _createElementVNode("cite", _hoisted_4, _toDisplayString(_ctx.d.testimonial.client.title), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
